<template>
    <div class="row mx-0 w-100" :id="widgetId">
        <slot/>
        <div class="row mx-0 w-100 cart-options-section" :id="cartOptionsId"
             :class="{ 
                'single-option' : (singleOption && primaryOptions && primaryOptions[0].type !== 'sizeId'), 
                'single-option-size' : (singleOption && primaryOptions && primaryOptions[0].type === 'sizeId'),
                'cart-options-cols' : showPrimarySelect && showSecondarySelect
             }"
        >
            <!-- Primary Options Select -->
            <QuickSelectBtn
                v-if="showPrimarySelect"
                v-model="selectedOptions.primary"
                class="select1"
                :key="primaryOptions[0].type"
                :current-selection="'primary'"
                :item-id="itemId"
                :label="primaryLabel"
                :options="primaryOptions"
                :option-type="primaryOptions[0].type"
                :default-value="selectedOptions.primary"
                :disableInput="outOfStock"
                :combo-cart-mode="comboCartMode || multiCartMode"
                :empty-selection-warning="emptySelectionWarning"
                @update-cart-option="updateCartOption"
            />

            <!-- Secondary Options Select -->
            <QuickSelectBtn
                v-if="showSecondarySelect"
                v-model="selectedOptions.secondary"
                :key="secondaryOptions[0].type"
                :currentSelection="'secondary'"
                :item-id="itemId"
                :label="secondaryLabel"
                :options="secondaryOptions"
                :optionType="secondaryOptions[0].type"
                :defaultValue="selectedOptions.secondary"
                :disableInput="outOfStock"
                :combo-cart-mode="comboCartMode || multiCartMode"
                :emptySelectionWarning="emptySelectionWarning || selectedProduct.warningDescription"
                :is-native="(!isDesktop && !multiCartMode)"
                @update-cart-option="updateCartOption"
            />
            
            <!--QuickRadio
                v-if="!isBlackRabbit && (useThumbRadios && showSecondarySelect)"
                v-model="selectedOptions.secondary"
                :key="secondaryOptions[0].type"
                :current-selection="'secondary'"
                :default-value="selectedOptions.secondary"
                :item-id="itemId"
                :label="!isBlackRabbit ? secondaryLabel : ''"
                :options="secondaryOptions"
                :disable-input="outOfStock"
                :combo-cart-mode="comboCartMode || multiCartMode"
                :empty-selection-warning="emptySelectionWarning || selectedProduct.warningDescription"
                @update-cart-option="updateCartOption"
            /-->

            <!-- Quantity Select ONLY -->
<!--            <QuickSelectBtn
                v-if="showQuantity"
                :label="kStrings.kGLOB_QUANTITY"
                :disable-input="qtyLimit == 1 || outOfStock"
                :option-type="'qty'"
                :qty-limit="qtyLimit"
                :empty-selection-warning="emptySelectionWarning && dynamicErrorMsg"
           />-->
            
            <p v-if="multiCartMode && (selectedProduct && selectedProduct.warningDescription)" class="warning-description"> <i class="ecom-info"/> {{ selectedProduct.warningDescription }} </p>
        </div>

        <!-- Primary Options Carousel (i think primary options are not being used)-->
        <!--QuickCarousel
            v-if="!isBlackRabbit && showPrimaryCarousel"
            v-model="selectedOptions.primary"
            :key="primaryOptions[0].type"
            :current-selection="'primary'"
            :item-id="itemId"
            :options="primaryOptions"
            :option-type="primaryOptions[0].type"
            :label="primaryLabel"
            :default-value="selectedOptions.primary"
            :empty-selection-warning="emptySelectionWarning"
            @update-cart-option="updateCartOption"
        /-->

        <!-- Secondary Options Carousel -->
        <!--QuickCarousel
            v-if="!isBlackRabbit && showSecondaryCarousel"
            v-model="selectedOptions.secondary"
            :key="secondaryOptions[0].type"
            :current-selection="'secondary'"
            :item-id="itemId"
            :options="secondaryOptions"
            :option-type="secondaryOptions[0].type"
            :label="!isBlackRabbit ? secondaryLabel : ''"
            :default-value="selectedOptions.secondary"
            :empty-selection-warning="emptySelectionWarning || selectedProduct.warningDescription"
            @update-cart-option="updateCartOption"
        /-->
    </div>
</template>

<script>

import QuickCarousel from '@/components/ComboCart/widgets/selectors/QuickCarousel';
import QuickRadio from '@/components/ComboCart/widgets/selectors/QuickRadio';
import QuickSelectBtn from '@/components/ComboCart/widgets/selectors/QuickSelectBtn.vue';

import {storeCombos} from '@/store/comboCart';
import {findKey, isEmpty, remove} from 'lodash-es';

export default {
    storeCombos,
    name: 'ProductOptions',
    components: {
        QuickCarousel,
        QuickRadio,
        QuickSelectBtn,
    },
    props: {
        data: Object,
        options: Array,
        currency: String,
        comboCartMode: {
            type: Boolean,
            default: false,
        },
        multiCartMode: {
            type: Boolean,
            default: false,
        },
        singleOption: {
            type: Boolean,
            default: false,
        },
        canAddToCart: {
            type: Boolean,
            default: false,
        },
        itemId: {
            type: String,
            default: '0',
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
        outOfStock: {
            type: Boolean,
            default: false,
        },
        qtyLimit: {
            type: Number,
            default: 5,
        },
        showQuantity: {
            type: Boolean,
            default: true,
        },
        useThumbRadios: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            selectedOptions: {
                primary: null,
                secondary: null,
            },
            currentSelection: 'primary',
            optionTypes: {
                primary: {
                    type: '',
                    labelKey: '',
                    descriptionKey: '',
                },
                secondary: {
                    type: '',
                    labelKey: '',
                    descriptionKey: '',
                },
            },
            //showPopupSelection: false
        };
    },
    computed: {
        isDesktop() {
            return storeCombos.getters.isDesktop;
        },
        widgetId() {
            return this.comboCartMode ? 'cartWidget-' + this.itemId : 'cartWidget';
        },
        cartOptionsId() {
            return this.comboCartMode ? 'cartOptions-' + this.itemId : 'cartOptions';
        },
        kStrings() {
            return storeCombos.getters.kStrings;
        },
        carouselTypes() {
            return storeCombos.getters.carouselTypes;
        },
        primaryLabel() {
            return this.primaryOptions.length && this.primaryOptions[0].label ? this.primaryOptions[0].label: kStrings.kGLOB_OPTION;
        },
        secondaryLabel() {
            return this.secondaryOptions.length && this.secondaryOptions[0].label ? this.secondaryOptions[0].label: kStrings.kGLOB_OPTION;
        },
        showPrimarySelect() {
            // const show = (this.primaryOptions && this.primaryOptions.length && !this.hideOptionsSelect && this.primaryOptions[0].type == 'sizeId' && this.singleOption) 
            //     || (this.primaryOptions && !this.hideOptionsSelect && !this.singleOption && this.secondaryOptions && this.secondaryOptions.length && this.secondaryOptions[0].type != 'sizeId');
            if(!this.primaryOptions || this.hideOptionsSelect){
                return false;
            }
            return true; //(this.singleOption) || (!this.singleOption && this.secondaryOptions && this.secondaryOptions.length && this.secondaryOptions[0].type != 'sizeId');
        },
        showPrimaryCarousel() {
            // refactored this method and discarded validation of "this.hideOptionsSelect" because
            // this component is only used in combos (this.hideOptionsSelect is always true)
            if(!this.multiCartMode && (!this.isDesktop || !this.primaryOptions || this.primaryOptions.length == 0)) {
                return false;
            }
            if(this.singleOption){
                return this.primaryOptions && this.primaryOptions[0].type != 'sizeId';
            }
            
            return this.secondaryOptions && this.secondaryOptions.length && (this.secondaryOptions[0].type == 'sizeId' || (this.secondaryOptions[0].type == 'sizeId' && this.multiCartMode));
        },
        showSecondarySelect() {
           /* if(!this.isDesktop) {
                return this.secondaryOptions && this.secondaryOptions.length;
            }*/
            return !this.singleOption && this.secondaryOptions && this.secondaryOptions.length;
            //return this.secondaryOptions && (this.isBlackRabbit || this.secondaryOptions[0].type == 'sizeId') && !this.singleOption;
        },
        showSecondaryCarousel() {
           /* if(!this.isDesktop) {
                return false;
            }*/
            return this.secondaryOptions && this.secondaryOptions.length && this.secondaryOptions[0].type != 'sizeId';
        },
        primaryOptions() {
            if (!isEmpty(this.data.optionTypes) && !isEmpty(this.optionTypes.primary.type)) {
                //console.log('this.data.productsList '+ this.itemId, this.data.productsList)
                let optionsList = this.getDistinct(this.data.productsList, this.optionTypes.primary.type,
                    'primary').
                    map(option => ({...option, stock: this.checkOptionStock(option.type, option.id)}));
                //console.log('optionsList', optionsList);
                // lmao size sort
                if (this.optionTypes.primary.type === 'sizeId') {
                    //optionsList = optionsList.sort((a, b) => (a.sizeOrder < b.sizeOrder) ? 1 : -1);
                    if (optionsList[0].sizeOrder !== null) { // cache problems, temp fix
                        optionsList = optionsList.sort((a, b) => a.sizeOrder ? a.sizeOrder.localeCompare(b.sizeOrder) : a.sizeOrder < b.sizeOrder);
                    }
                    //console.log(optionsList);
                }

                // force first option as default, otherwise will trigger error "selectedOptions.primary is undefined"
                let k = 0;
                //console.log('this.data.componentOrder[0].default', this.data.componentOrder[0].default)
                if (this.data.componentOrder[0].default !== null) {
                    const defaultOptionId = this.data.componentOrder[0].default;
                    // try to find key for option
                    const temp = findKey(optionsList, option => option.id === defaultOptionId);
                    if(typeof temp !== 'undefined'){
                        k = temp;
                    }
                }
                optionsList[k].default = true;
                
                if(this.multiCartMode) {
                    return this.carouselTypes.includes(this.optionTypes.primary.type) ? this.organizeOptionsByStock(
                        optionsList).filter(opt => opt.stock > 0) : optionsList;
                }

                return this.carouselTypes.includes(this.optionTypes.primary.type) ? this.organizeOptionsByStock(
                    optionsList) : optionsList;
            }

            return null;
        },
        secondaryOptions() {
            if (!isEmpty(this.selectedOptions.primary) && !this.singleOption) {
                let secondaryOptions = this.data.productsList.filter(
                    x => x[this.selectedOptions.primary.type] == this.selectedOptions.primary.id).map(
                    item => new this.optionsObject(item, this.optionTypes.secondary.type, 'secondary',
                        this.optionTypes),
                );

                if (this.optionTypes.secondary.type === 'sizeId') {
                    if (secondaryOptions[0].sizeOrder !== null) {
                        secondaryOptions = secondaryOptions.sort((a, b) => a.sizeOrder ? a.sizeOrder.localeCompare(b.sizeOrder) : a.sizeOrder < b.sizeOrder);
                        if(this.multiCartMode) {
                            secondaryOptions = secondaryOptions.filter(opt => opt.stock > 0);
                        }
                    }
                }

                if(!this.comboCartMode) {
                    return this.carouselTypes.includes(this.optionTypes.secondary.type)
                        ? this.organizeOptionsByStock(secondaryOptions)
                        : secondaryOptions;
                } else {
                    return this.carouselTypes.includes(this.optionTypes.secondary.type)
                        ? this.organizeOptionsByStock(secondaryOptions).filter(opt => opt.stock > 0)
                        : secondaryOptions;
                }
                
            }
            return null;
        },
        selectedProduct() {
            if (this.singleOption && !isEmpty(this.selectedOptions.primary)) {
                return this.data.productsList.find(
                    product => product[this.optionTypes.primary.type] === this.selectedOptions.primary.id);
            } else {
                if (!isEmpty(this.selectedOptions.primary) && !isEmpty(this.selectedOptions.secondary)) {
                    return this.data.productsList.find(
                        product => product[this.optionTypes.primary.type] === this.selectedOptions.primary.id &&
                            product[this.optionTypes.secondary.type] === this.selectedOptions.secondary.id,
                    );
                }
            }
            return this.selectedOptions[this.currentSelection];
        },
        sku() {
            return this.selectedProduct ? this.selectedProduct.sku : null;
        },
        optionsInStock() {
            if (this.selectedProduct && this.selectedProduct.stock < 1 && this.secondaryOptions) {
                return this.data.productsList.filter(
                    product => product[this.optionTypes.secondary.type] == this.selectedOptions.secondary.id &&
                        product.stock > 0).map(option => option[this.optionTypes.primary.descriptionKey],
                );
            }
            return [];
        },
        hideOptionsSelect() {
            return this.multiCartMode;
        },
        isBlackRabbit() {
            return storeCombos.getters.isBlackRabbit;
        },
    },
    methods: {
        setOptionTypes: function(optionTypes, fieldKeys, componentOrder) {
            // If has 2 options or just one
            //console.log('this.singleOption '+this.itemId, this.singleOption, componentOrder);
            if (!this.singleOption) {
                this.optionTypes.primary.type = componentOrder[0].component;
                this.optionTypes.primary.labelKey = fieldKeys.hasOwnProperty(this.optionTypes.primary.type) ? fieldKeys[this.optionTypes.primary.type].label : '';
                this.optionTypes.primary.descriptionKey = fieldKeys.hasOwnProperty(this.optionTypes.primary.type) ? fieldKeys[this.optionTypes.primary.type].desc  : '';
                this.optionTypes.secondary.type = componentOrder[1].component;
                this.optionTypes.secondary.labelKey = fieldKeys.hasOwnProperty(this.optionTypes.secondary.type) ? fieldKeys[this.optionTypes.secondary.type].label : '';
                this.optionTypes.secondary.descriptionKey = fieldKeys.hasOwnProperty(this.optionTypes.secondary.type) ? fieldKeys[this.optionTypes.secondary.type].desc : '';
            } else {
                this.optionTypes.primary.type = componentOrder[0] ? componentOrder[0].component : null;
                this.optionTypes.primary.labelKey = fieldKeys.hasOwnProperty(this.optionTypes.primary.type) ? fieldKeys[this.optionTypes.primary.type].label : '';
                this.optionTypes.primary.descriptionKey = fieldKeys.hasOwnProperty(this.optionTypes.primary.type) ? fieldKeys[this.optionTypes.primary.type].desc : '';
            }
        },

        checkOptionStock: function(optionType, optionId) {
            return !isEmpty(this.data.productsList.filter(product => product[optionType] == optionId && product.stock > 0));
        },

        getDistinct(data, field, optionType) {
            const unique = [];
            const map = new Map();
            for (const item of data) {
                if (!map.has(item[field])) {
                    map.set(item[field], true);
                    unique.push(new this.optionsObject(item, field, optionType, this.optionTypes));
                }
            }
            return unique;
        },

        optionsObject(item, field, optionType, optionTypes) {
            this.id = item[field];
            this.order = item.order ? item.order : null;
            this.property = field;
            this.images = item.images ? item.images : [];
            this.price = item.price ? item.price : null;
            this.priceVal = item.priceVal ? item.priceVal : null;
            this.stock = item.stock ? item.stock : null;
            this.partnerPrice = item.priceCrossed ? item.priceCrossed : null;
            this.partnerPriceVal = item.priceCrossedVal ? item.priceCrossedVal : null;
            this.description = item[optionTypes[optionType].descriptionKey];
            this.label = item[optionTypes[optionType].labelKey] ? item[optionTypes[optionType].labelKey] : '';
            this.availableDate = item.availableDate ? item.availableDate : null;
            this.varSku = item.varSku ? item.varSku : null;
            this.default = false;
            this.type = field;
            this.sizeOrder = item.sizeOrder ? item.sizeOrder : null;
            this.groupId = item.relativeGroupId; // relativeGroupId is the correct for the selected primary variant
            this.reload = item.reload;
            this.variantInfoData = item.variantInfoData ? item.variantInfoData : null;
            this.redirectUrl = item.redirectUrl ? item.redirectUrl : null;
            this.unitFactor = item.unitFactor ? item.unitFactor : null;
            this.packIndex = this.itemIndex;
            this.overrideStatus = item.overrideStatus ? item.overrideStatus : null;
        },

        organizeOptionsByStock(options) {
            let originalOptions = [...options];
            let outOfStock = remove(originalOptions, option => option.stock < 1);
            return !isEmpty(outOfStock) ? originalOptions.concat(outOfStock) : originalOptions;
        },

        // updateCartOption aux
        setCurrentSelectionOptions: function(optionToSelect) {
            this.currentSelection = optionToSelect;
            if (optionToSelect === 'primary') {
                if (this.selectedOptions.secondary) {
                    this.selectedOptions.secondary = null
                }

                if (!this.selectedOptions.primary) {
                    this.selectedOptions.primary = this.primaryOptions[0];
                }
            } else if (isEmpty(this.selectedOptions.secondary)) {
                let firstProductWithStock =
                    this.secondaryOptions.find(product => product.stock > 0);
                this.selectedOptions.secondary = firstProductWithStock
                    ? firstProductWithStock
                    : this.secondaryOptions[0];
            }
        },

        // 2nd most important function of this component, reloads & some flow control (REMAKING ALL OF IT)
        updateCartOption: function(currentSelection) {
            this.currentSelection = currentSelection;
            this.setCurrentSelectionOptions(this.currentSelection);
            let selectedProduct = this.selectedProduct;
            if(this.multiCartMode) {
                let hasEmptySecondary = (!this.singleOption && this.secondaryOptions && this.secondaryOptions.length) && isEmpty(this.selectedOptions.secondary);
                selectedProduct['emptyWidget'] = hasEmptySecondary;
                let labelString = this.kStrings.kCHOOSE_OPTION_FIRST;
                selectedProduct['warningDescription'] = hasEmptySecondary ? labelString.replace('label_key', this.secondaryLabel.toLowerCase()) : '';
                if(selectedProduct.stock == 0) {
                    selectedProduct['warningDescription'] = this.kStrings.kPROD_STOCK_OUT;
                }
            }
            this.$emit('input', selectedProduct);
        },
        
    },
    watch: {
        showSecondaryCarousel(value) {
            if(value) {
                //console.log('emitted carousel type');
                this.$emit('has-carousel');
            }
        } 
    },
//    created() {},
    mounted() {
        this.$nextTick(() => {
            this.setOptionTypes(this.data.optionTypes, this.data.fieldKeys, this.data.componentOrder);
            // Set Primary Option List and Active Primary Option
            if (this.primaryOptions) {
                this.selectedOptions.primary = this.primaryOptions.find(option => option.default === true);
                if (!this.singleOption && isEmpty(this.selectedOptions.primary)) {
                    this.selectedOptions.primary = this.primaryOptions[0];
                    this.selectedOptions.primary.default = true;
                }
            }

            if (this.secondaryOptions) {
                if(this.secondaryOptions.length == 1){
                    this.$emit('input', this.secondaryOptions[0]);
                }

                let defaultComponentId = this.data.componentOrder[1].default ? this.data.componentOrder[1].default : null;
                if (defaultComponentId) {
                    this.selectedOptions.secondary = this.secondaryOptions.find(option => option.id === defaultComponentId);
                }
            }
            
            if(this.singleOption) {
                this.$emit('input', this.data.productsList.find(product => product[this.optionTypes.primary.type] === this.selectedOptions.primary.id));
            }
        });
    },
};
</script>

<style lang="scss" scoped></style>
